<template>
  <div class="topnav">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg">
        <div id="topnav-menu-content" class="collapse navbar-collapse">
          <ul class="navbar-nav">
            <b-dropdown
              as="li"
              class="nav-item"
              toggle-class="nav-link dropdown-toggle arrow-none"
              menu-class="dropdown-menu"
              variant="link"
            >
              <template #button-content>
                <i class="uil-dashboard"></i>Dashboard
                <div class="arrow-down"></div>
              </template>
              <template #default>
                <router-link to="/" class="dropdown-item side-nav-link-ref">NEW</router-link>
                <router-link to="/shipments" class="dropdown-item side-nav-link-ref">Shipments</router-link>
                <router-link to="/assignments" class="dropdown-item side-nav-link-ref">Assignments</router-link>
                <router-link to="/customers" class="dropdown-item side-nav-link-ref">Customers</router-link>
              </template>
            </b-dropdown>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'

export default defineComponent({
  setup() {
    const activateMenuItems = () => {
      const links = document.getElementsByClassName('side-nav-link-ref')

      let menuItemEl: Element | null = null
      for (let i = 0; i < links.length; i++) {
        const link = links[i] as HTMLAnchorElement
        if (window.location.pathname === link.getAttribute('href')) {
          menuItemEl = link
          break
        }
      }

      if (menuItemEl) {
        menuItemEl.classList.add('active')
        let parentEl = menuItemEl.parentElement

        // Apply active classes up the DOM tree to maintain nested menu highlighting
        while (parentEl) {
          parentEl.classList.add('active')
          parentEl = parentEl.parentElement
        }
      }
    }

    onMounted(activateMenuItems)
  },
})
</script>
